import styled from 'styled-components';

const StepsContainer = styled.div`
  position: relative;
  min-height: fit-content;
  margin-bottom: 20px;
  button, 
  * button,
  .ui.button { 
   color: white !important;
  }
  .bar {
    background: ${props => props.theme.firstColor} !important;
  }
`;

const Step = styled.div<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  z-index: 2;
  align-items: center;
  color: ${props => (props.$active ? props.theme.firstColor : props.theme.secondColor)};
  position: relative;
   .stepTitle {
    position: absolute;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical; 
    white-space: normal;
    max-width: 140px; 
    text-align: center;
    overflow: hidden; 
    top: 60px;
    font-size: 15px !important;
    font-weight: ${props => props.$active ? 'bold' : '400'};
   }
`;

const StepIcon = styled.div<{ $active?: boolean, $dataLoaded?: boolean }>` 
  background: white;
  border-radius: 50%;
  color: #fff;
  cursor: ${props => props.$dataLoaded ? 'pointer' : 'default'};
  border: ${props => props.$active ? '3px solid' : '2px dashed'};
  border-color: ${props => props.theme.firstColor} ;
  font-size: 28px;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  height: 50px;
  ${props => props.$active ? 'filter: drop-shadow(2px 4px 6px black)' : ''};  
  line-height: 50px;
  margin-bottom: 10px;
  width: 50px;
  div {
    font-size: 25px !important;  
  }
  .ui.loader {
    top: 43% !important;
  }
`;

const Steps = styled.div`
  display: flex;
  justify-content: space-around;  
`;

export const SliderContainer = styled.div`
 label {
  color: black !important;
 }
`

const Title = styled.h3`
  color: ${props => props.theme.firstColor};
  display: flex;
  align-items: center;
  gap: 0.3em;
`

const SubTitle = styled.h2`
  color: ${props => props.theme.firstColor};
  font-size: 1.3em;
  margin-top: 2em;
  margin-bottom: 1em;
`

const WelcomeText = styled.p`
  font-size: 1.1em;
  line-height: 1.6;
  margin-bottom: 1.5em;
`

const InfoSection = styled.div`
  margin-bottom: 2em;
`

const InfoText = styled.p`
  font-size: 1em;
  line-height: 1.6;
  margin-bottom: 1em;
  color: #333;
`

const LinkButton = styled.button`
  background: none;
  border: none;
  background: ${props => props.theme.firstColor};
  text-decoration: underline;
  cursor: pointer;
  font-size: 1em;
  padding: 5px;
  border-radius: 5px;
  color: white;
  font-weight: 600;
  
  &:hover {
    opacity: 0.8;
  }
`
export const GeneralEl = {
  LinkButton,
  InfoSection,
  InfoText,
  SubTitle,
  Title,
  WelcomeText
}

export const CoolFarmEl = {
  Step,
  StepIcon,
  StepsContainer,
  Steps
}